import type { RefObject } from 'react';
import { useLayoutEffect, useRef } from 'react';

export const useSyncSize = <S extends HTMLElement, T extends HTMLElement>({
  sourceRef,
  targetRef,
}: {
  sourceRef: RefObject<S>;
  targetRef: RefObject<T>;
}): void => {
  const resizeObserverRef = useRef(
    new ResizeObserver(() => {
      const target = targetRef.current;
      if (target === null || sourceRef.current === null) return;
      const boundingRect = sourceRef.current.getBoundingClientRect();
      target.style.width = `${boundingRect.width}px`;
    }),
  );

  useLayoutEffect(() => {
    const resizeObserver = resizeObserverRef.current;
    const listBox = sourceRef.current;
    if (listBox === null) return;
    const target = targetRef.current;
    if (target === null || sourceRef.current === null) return;
    const boundingRect = sourceRef.current.getBoundingClientRect();
    target.style.width = `${boundingRect.width}px`;
    resizeObserver.observe(listBox);
    return () => resizeObserver.unobserve(listBox);
  });
};
